import {useEffect, useState} from "react";
import {AccountApi} from "../AccountApi";
import {downloadUsageView, type DownloadUsageView} from "../downloadUsage";

/**
 * Thin adapter for the sender's monthly download meter (ui#309): fetches `GetDownloadUsage`
 * once per mount while logged in and exposes the domain-shaped view. All policy (thresholds, when the
 * banner shows) lives in {@link ../downloadUsage}; a fetch failure or logged-out state simply meters
 * nothing — usage display must never break the create flow.
 */
export function useDownloadUsage(loggedIn: boolean): DownloadUsageView | null {
	const [view, setView] = useState<DownloadUsageView | null>(null);

	useEffect(() => {
		if (!loggedIn) {
			setView(null);
			return;
		}
		let cancelled = false;
		AccountApi.getDownloadUsage()
			.then((usage) => {
				if (!cancelled) {
					setView(downloadUsageView(usage));
				}
			})
			.catch(() => {
				if (!cancelled) {
					setView(null);
				}
			});
		return () => {
			cancelled = true;
		};
	}, [loggedIn]);

	return view;
}
